const BLOCK = 'LStudio__app_table';

/*
    🔥 VISTA EN GRILLA

    ⚠️ SIN renderGridItem, LA GRILLA SE ARMA SOLA CON LAS COLUMNAS

    La primera columna va como título, las que tengan `render` van como
    contenido, y el resto como pares etiqueta-valor. No queda perfecto,
    pero funciona sin escribir nada.

    Para que quede bien, se le pasa `renderGridItem(row)` y ahí armás
    la tarjeta que quieras.

    ⚠️ LAS COLUMNAS OCULTAS EN MOBILE TAMBIÉN SE OCULTAN ACÁ

    Si una columna es secundaria en la tabla, en una tarjeta chica
    también sobra.
*/

const onGetValue = (row, key) => (
    key.split('.').reduce((acc, part) => acc?.[part], row)
);

export const TableGrid = ({
    rows = [],
    columns = [],
    rowKey = 'id',
    renderGridItem = null,
    isSelectable = false,
    selected = [],
    onSelectChange = null,
    isRowSelectable = null,
    rowActions = null,
    onRowClick = null,
    columnsCount = 3,
}) => {

    const onIsSelectable = (row) => (isRowSelectable ? isRowSelectable(row) : true);

    const onToggleRow = (key) => onSelectChange?.(
        selected.includes(key) ? selected.filter((k) => k !== key) : [...selected, key],
    );

    /* 🔥 Tarjeta por defecto, armada desde las columnas */
    const onRenderDefault = (row) => {

        const [FIRST, ...REST] = columns;

        return (
            <>
                <div className={`${BLOCK}__card_head`}>
                    <span className={`${BLOCK}__card_title`}>
                        {FIRST?.render ? FIRST.render(row) : onGetValue(row, FIRST?.key)}
                    </span>
                </div>

                <dl className={`${BLOCK}__card_data`}>
                    {
                        REST.filter((col) => !col.isHiddenOnMobile).map((col) => (
                            <div key={col.key} className={`${BLOCK}__card_field`}>
                                <dt>{col.label}</dt>
                                <dd>{col.render ? col.render(row) : onGetValue(row, col.key)}</dd>
                            </div>
                        ))
                    }
                </dl>
            </>
        );
    };

    return (
        <div className={`${BLOCK}__grid`} style={{ '--LS__grid_columns': columnsCount }}>
            {
                rows.map((row) => {

                    const KEY = onGetValue(row, rowKey);
                    const IS_SELECTED = selected.includes(KEY);
                    const CAN_SELECT = onIsSelectable(row);

                    return (
                        <article key={KEY} className={`${BLOCK}__card`}
                            data-selected={IS_SELECTED}
                            data-locked={!CAN_SELECT}
                            data-clickable={!!onRowClick}
                            onClick={onRowClick ? () => onRowClick(row) : undefined} >

                            {
                                isSelectable && CAN_SELECT && (
                                    <input type="checkbox" className={`${BLOCK}__card_check`}
                                        checked={IS_SELECTED}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={() => onToggleRow(KEY)}
                                        aria-label={`Seleccionar ${KEY}`} />
                                )
                            }

                            {renderGridItem ? renderGridItem(row) : onRenderDefault(row)}

                            {
                                rowActions && (
                                    <div className={`${BLOCK}__card_actions`}
                                        onClick={(e) => e.stopPropagation()} >
                                        {rowActions(row)}
                                    </div>
                                )
                            }

                        </article>
                    );
                })
            }
        </div>
    );
};
